//---------------------------------------------------------
// Control-plane address for the firewall preview.
// Never hardcode an environment's address in the bundle. Resolution order:
//   1. REACT_APP_CONTROL_PLANE_CIDR (build-time, optional; "a.b.c.d" or "a.b.c.d/32")
//   2. the address the console is served from (the CP edge), when it is an
//      IPv4 literal — the lab is reached at https://<cp-ip>:8443
// The rule is locked to a /32.
//---------------------------------------------------------

const IPV4 = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

export const CP_UNKNOWN_SOURCE = 'the control-plane address';

export function controlPlaneCidr(envValue: string | undefined | null, hostname: string | undefined | null): string | null {
	const fromEnv = (envValue || '').trim().split('/')[0];
	if (fromEnv && IPV4.test(fromEnv)) return `${fromEnv}/32`;
	const host = (hostname || '').trim();
	if (host && IPV4.test(host)) return `${host}/32`;
	return null;
}

/** This environment's control-plane /32, from env or the serving address. */
export function currentControlPlaneCidr(): string | null {
	const host = typeof window !== 'undefined' ? window.location.hostname : '';
	return controlPlaneCidr(process.env.REACT_APP_CONTROL_PLANE_CIDR, host);
}

export function cp11111Line(cidr: string | null): string {
	return `TCP 11111 from ${cidr ?? `${CP_UNKNOWN_SOURCE}/32`}`;
}

export type FirewallPreviewChoice = {kind: 'existing'; firewall: {cp11111: string}} | {kind: 'new'; label: string} | null;

export function firewallPreviewLines(choice: FirewallPreviewChoice, cidr: string | null): string[] {
	if (!choice) return [];
	if (choice.kind === 'new') {
		return ['TCP 80 and 443, UDP 8079, from anywhere', 'TCP and UDP from 192.168.128.0/17', cp11111Line(cidr)];
	}
	const lines = [cp11111Line(cidr)];
	if (choice.firewall.cp11111 === 'open') {
		lines.push('This firewall already allows TCP 11111 from anywhere.');
	}
	return lines;
}
